"use client";

import { useAppContext } from "@/context/AppContextProvider";
import { useSession } from "next-auth/react";
import Link from "next/link";
import { FC, useEffect, useState } from "react";
import SignInButton from "@/components/SignInButton";
import Image from "next/image";
import { useUserGetProfile } from "@/hooks/user/useUserGetProfile";
import ImageIconComponent from "@/components/icons/ImageIconComponent";
import { URLConstants } from "@/constants/URLConstants";
import { useRouter } from "next/navigation";
import { BREAK_POINT_CONSTANTS } from "@/constants/AppConstants";
import UserMypageSettingMenu from "@/components/molecules/SettingMenu/UserMypageSettingMenu";


const HomeHeader: FC<{ userIconClassName?: string; }> = ({ userIconClassName = '' }) => {
  const { visableMode, setScreenType } = useAppContext();
  const { data: session, status } = useSession();
  const router = useRouter();
  const user = session?.user;
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 0
  );
  const { data: userProfile, isLoading: profileLoading } = useUserGetProfile({
    userUuid: user?.id ?? ''
  });

  useEffect(() => {
    if (typeof window === undefined) return;

    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    // イベントリスナーを登録
    window.addEventListener("resize", handleResize);

    // クリーンアップ関数（イベントリスナーの解除）
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const renderRight = () => {
    // セッション確認中はプレースホルダ（レイアウトシフト防止）
    if (status === "loading") {
      return <div className="w-10 h-10" />;
    }
    // 認証済み & プロフィール取得済み → ユーザーメニュー
    if (status === "authenticated" && user && userProfile) {
      return (
        <div
          className="cursor-pointer"
          onClick={(e) => { e.stopPropagation(); setScreenType('grid'); router.push(URLConstants.user.mypage.pathname); }}
        >
          <UserMypageSettingMenu />
        </div>
      );
    }
    // 未ログイン または プロフィール未取得 → Login ボタン
    return <SignInButton />;
  };

  return (
    <header
      className={`fixed z-[100] top-0 w-full min-w-screen-sm bg-black bg-opacity-90 settingArea ${visableMode.isShow ? "fade-in" : "fade-out"}`}
    >
      <div className="relative min-h-[50px] p-[10px] flex justify-between">
        <div className="max-w-28">
          <a className="text-white" href="/">
            <h1 className="logoBox">
              <Image
                alt="picsle logo"
                src="/picsle_logo.svg"
                width={300}
                height={300}
                style={{ width: "100%", height: "auto" }}
                fill={false}
                priority={false}
              />
            </h1>
          </a>
        </div>
        <div>{renderRight()}</div>
      </div>
    </header>
  );
};

export default HomeHeader;
